import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from './global';
import { Plato } from '../models/plato';

@Injectable({
  providedIn: 'root'
})
export class RedsysService {

  constructor(
    private http: HttpClient
  ) { }

  // OBTENER INFO DE PLATO DESDE LARAVEL
  crearPago(pedidoId: any, novedadesRegistro: any): Observable<any> {
    const json = JSON.stringify({
      pedido_id: pedidoId,
      dominio: GLOBAL.urlApp,
      novedades_registro: novedadesRegistro
    });
    const params = json;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(GLOBAL.urlApi + 'redsys/create', params, { headers });
  }

}
